import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { appStateActions } from 'store/appStateSlice';
import { SuccessActionTypesEnum } from 'store/SuccessActionTypes.enum';
import { adminActions } from 'features/admin/store/slice';
import ActionButton from 'shared/components/buttons/ActionButton/ActionButton';
import { SnackbarTypeEnum } from 'shared/components/feedback/Snackbar/SnackbarTypes.enum';
import { usePerformActionOnSuccess } from 'shared/hooks/usePerformActionOnSuccess';

const UserActionButton = ({ userData: { id } }) => {
  const dispatch = useDispatch();

  const onButtonClick = useCallback(
    () =>
      dispatch(
        (adminActions.reInviteUser)(id),
      ),
    [id, dispatch],
  );

  const showSucessSnackBar = useCallback(
    (action) =>
      dispatch(
        appStateActions.showSnackbar({
          text: `The user will receive an email with instructions to ${action} their password.`,
          type: SnackbarTypeEnum.SUCCESS,
          duration: 10000,
          closable: true,
        }),
      ),
    [dispatch],
  );

  usePerformActionOnSuccess(SuccessActionTypesEnum.ADMIN_USER_REINVITED, () =>
    showSucessSnackBar('confirm'),
  );

  usePerformActionOnSuccess(
    SuccessActionTypesEnum.ADMIN_USER_PASSWORD_RESET,
    () => showSucessSnackBar('reset'),
  );

  return (
    <ActionButton
      type="button"
      variant="outlined"
      color="primary"
      onClick={onButtonClick}
    >
      REINVITE
    </ActionButton>
  );
};

UserActionButton.propTypes = {
  userData: PropTypes.shape({
    id: PropTypes.number,
    userAccountStatus: PropTypes.string,
  }).isRequired,
};

export default UserActionButton;
